import { routes } from 'helpers/routes'
import { Breadcrumb } from 'recoils/atoms'

export const HEADERS = [
  {
    key: 'no',
    label: 'common:header.no.label',
    sortable: false,
    width: 8,
  },
  {
    key: 'code',
    label: 'staff:staffId.column',
    sortable: true,
    width: 8,
  },
  {
    key: 'name',
    label: 'staff:staffName.column',
    sortable: true,
    width: 25,
  },
  {
    key: 'phoneNumber',
    label: 'staff:staffPhoneNumber.column',
    sortable: true,
    width: 12,
  },
  {
    key: 'role',
    label: 'staff:position.column',
    sortable: true,
    width: 12,
  },
  {
    key: 'area',
    label: 'staff:area.column',
    sortable: true,
    width: 25,
  },
  {
    key: 'status',
    label: 'common:header.status.label',
    sortable: false,
    width: 10,
  },
]

export const BREADCRUMBS_LIST: Breadcrumb[] = [
  { key: routes.staff.path, label: 'staffManagement.breadcrumb' },
]

export const renderBreadcrumbsEdit = (id: string): Breadcrumb[] => [
  { key: routes.staff.path, label: 'layout:staffManagement.breadcrumb' },
  {
    key: `${routes.staff.path}/${id}/edit`,
    label: 'layout:staffEdit.breadcrumb',
  },
]
